import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {TableComponent} from "../ui/table/table.component";
import {Product} from "../../models/shop/product";
import {ShopService} from "../../services/shop/shop.service";
import {CompanyService} from "../../services/company/company.service";
import {ShopBaseComponent} from "./shop-base.component";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import Swal from "sweetalert2";

@Component({
    selector: 'app-shop',
    templateUrl: './shop.component.html',
})
export class ShopComponent extends ShopBaseComponent implements OnInit {

    @ViewChild('productList') productList: TableComponent | undefined;
    companyId: string = localStorage.getItem('wisper_companyId') ?? '';
    /** null until first load completes (avoids empty-state flash while loading). */
    products: Product[] | null = null;
    currentIndex: number = 0;
    images: string[] = [];

    selectedBarcode: string = '';
    selectedQuantity: number = 1;

    constructor(public serviceInjector: Injector,
                public shopService: ShopService,
                private sanitizer: DomSanitizer,
                public companyService: CompanyService) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.showSpinner();
        if (this.companyId === '') {
            this.companyId = (await this.companyService.getCompanyFromShopDomain(window.location.hostname))?.id ?? '';
        }
        this.products = (await this.shopService.getProducts(this.companyId)) ?? [];
        this.hideSpinner();
    }

    async ngAfterViewInit() {
        this.showSpinner();
        this.productList?.loadData(`/products`, {companyId: this.companyId}, ((item: any) => new Product(item)))
        this.hideSpinner();
    }

    currentImage(): string {
        return this.images[this.currentIndex];
    }

    prevSlide() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    }

    nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }

    goToSlide(index: number) {
        if (index >= 0 && index < this.images.length) {
            this.currentIndex = index;
        }
    }

    showProductModal(product: Product) {
        if (product.images?.length) {
            this.images = product.images.map((image: any) => image.imageUrl);
        } else {
            const fallback =
                product.coverImage ||
                product.images?.[0]?.imageUrl ||
                'assets/images/no-image.png';
            this.images = [fallback];
        }

        this.ngxSmartModalService.getModal('viewProductModal').setData(product);
        this.ngxSmartModalService.getModal('viewProductModal').open().onClose.subscribe(() => {
            this.images = [];
            this.currentIndex = 0;
            this.selectedBarcode = '';
        });
    }


    addToCart() {
        let selectedProduct = this.products!.filter((product: any) =>
            product.barcode!.some((barcode: any) => barcode.id === this.selectedBarcode)
        );

        let productToCart = selectedProduct.map((product: any) => {
            let selectedBarcodeObject = product.barcode.find((barcode: any) => barcode.id === this.selectedBarcode);
            return {
                name: product.name,
                price: product.fullPrice === product.reducedPrice ? product.fullPrice : product.reducedPrice,
                imageUrl: product.images[0].imageUrl,
                barcode: this.selectedBarcode,
                quantity: this.selectedQuantity,
                color: selectedBarcodeObject.color.name,
                size: selectedBarcodeObject.size.name,
            }
        })
        this.selectedQuantity = 1;
        this.selectedBarcode = '';
        this.addProductLocalStorage(productToCart);
        this.showShopMessage();
        this.ngxSmartModalService.getModal('viewProductModal').close();
    }

    addToCartValidation() {
        return this.selectedBarcode && this.selectedQuantity && this.selectedQuantity > 0;
    }

    zoom(image: any) {
        this.ngxSmartModalService.getModal('zoomImageModal').setData(image, true);
        this.ngxSmartModalService.getModal('zoomImageModal').open();
    }

    getClearDescription(description: string) {
        return this.sanitizer.bypassSecurityTrustHtml( description );
    }

    showShopMessage() {
        return Swal.fire({
            icon: 'success',
            title: "Prodotto aggiunto al carrello",
            html: "Vuoi procedere con l'acquisto?",
            showCancelButton: true,
            confirmButtonText: "Si, procedi",
            cancelButtonText: "No, continua lo shopping",
        }).then((result) => {
            if (result.isConfirmed) {
               this.goTo('/shop/cart')
            } else {
                this.ngxSmartModalService.getModal('viewProductModal').close();
                this.ngxSmartModalService.getModal('zoomImageModal').close();
            }
        });
    }

    clearModalData() {
        this.selectedBarcode = '';
    }
}

